import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type RereadCodeBookImportMutationVariables = Types.Exact<{
  importId: Types.Scalars['uuid']['input'];
}>;


export type RereadCodeBookImportMutation = { __typename?: 'mutation_root', reread_code_book_import?: { __typename?: 'CodeBookImportStartedOutput', import_id: any, status: string } | null };


export const RereadCodeBookImportDocument = gql`
    mutation rereadCodeBookImport($importId: uuid!) {
  reread_code_book_import(input: {import_id: $importId}) {
    import_id
    status
  }
}
    `;
export type RereadCodeBookImportMutationFn = Apollo.MutationFunction<RereadCodeBookImportMutation, RereadCodeBookImportMutationVariables>;

/**
 * __useRereadCodeBookImportMutation__
 *
 * To run a mutation, you first call `useRereadCodeBookImportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRereadCodeBookImportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rereadCodeBookImportMutation, { data, loading, error }] = useRereadCodeBookImportMutation({
 *   variables: {
 *      importId: // value for 'importId'
 *   },
 * });
 */
export function useRereadCodeBookImportMutation(baseOptions?: Apollo.MutationHookOptions<RereadCodeBookImportMutation, RereadCodeBookImportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RereadCodeBookImportMutation, RereadCodeBookImportMutationVariables>(RereadCodeBookImportDocument, options);
      }
export type RereadCodeBookImportMutationHookResult = ReturnType<typeof useRereadCodeBookImportMutation>;
export type RereadCodeBookImportMutationResult = Apollo.MutationResult<RereadCodeBookImportMutation>;
export type RereadCodeBookImportMutationOptions = Apollo.BaseMutationOptions<RereadCodeBookImportMutation, RereadCodeBookImportMutationVariables>;